// @flow
import { push } from "connected-react-router"
import { assertNever } from "common/flow"
import type { Epic } from "common/redux/types"
import { noopAction } from "common/redux/actions"
import urls from "data/router/urls"
import { selectPathname } from "data/router/selectors"
import { onSearchPage, onAffiliatePage, onProductPage } from "data/router/helpers"
import { filter, type SearchAction } from "./actions"

const searchEpic: Epic<SearchAction> = (action$, store) =>
  action$
    // $ExpectError
    .ofType("SEARCH/FILTER", "SEARCH/FILTER_DATES")
    .map(action => {
      if (
        action.type !== "SEARCH/FILTER" &&
        action.type !== "SEARCH/FILTER_DATES"
      ) {
        throw new Error("impossible")
      }

      const path = selectPathname(store.getState())

      // dont do anything if already on search, on affiliate page or just navigating to a product
      if (onSearchPage(path)
        || onAffiliatePage(path)
        || (onProductPage(path) && !action.payload.product)) {

        return noopAction()
      }

      // redirect to search
      return push(urls.search)
    })

const triggerSearchEpic: Epic<SearchAction> = (action$, store) =>
  action$
    // $ExpectError
    .ofType("SEARCH/ADD_RECENT_SEARCH", "SEARCH/TRIGGER_RECENT_SEARCH")
    .map(action => {
      if (
        action.type !== "SEARCH/ADD_RECENT_SEARCH" &&
        action.type !== "SEARCH/TRIGGER_RECENT_SEARCH"
      ) {
        throw new Error("impossible")
      }

      switch (action.payload.type) {
        case "affiliate":
          return noopAction()
        case "manufacturer":
          return filter({ brand: [action.payload] })
        case "product":
          return filter({ product: [action.payload] })
        default:
          return assertNever(action.payload.type)
      }
    })

export default [searchEpic, triggerSearchEpic]



// WEBPACK FOOTER //
// ./src/data/search/epics.js